import { MiddlewareStore } from 'store/createStore';
import { setEndChatConfirm } from 'store/app/app.actions';
import { postMessageToParent, setCSSVar } from 'utils';
import { SmartagentChatWebsocketType } from '@missionlabs/smartagent-bchat';

import MessagesTypes from 'store/messages/messages.types';

let listening = false;
let ws: SmartagentChatWebsocketType | null;
const listenToLoaderMessages = async (store: MiddlewareStore) => {
    postMessageToParent('smartagent-get-css-variables', {});

    const listener = async (message: MessageEvent) => {

        if (!message.data || message.data.type !== 'smartagent') return;

        switch (message.data.event) {
            case 'loader-close-chat':
                
                if (!store.getState().app.ended) {
                    store.dispatch<any>(setEndChatConfirm(true));
                } else {
                    invalidateChatLoaderWebsocket();
                    postMessageToParent('smartagent-minimise-loader', {});
                }
                return;
            case 'update-contact':
                if (!window.bchat) {
                    console.log('Error reading message: ', message);
                    throw new Error(`No websocket`);
                }
                console.log('message received', message);
                if (!message.data.data) {
                    postMessageToParent('update-contact-error', { error: 'No payload provided' });
                    return;
                }
                const data = {
                    ...message.data.data,
                    contactId: store.getState().app.contactId,
                };
                window.bchat.updateContact(data);
                return;
            case 'download-chat-transcript': {
                return store.dispatch({
                    type: MessagesTypes.GET_TRANSCRIPT
                })
            }
            case 'post-css-variables':
                console.log('got css variables from loader', message.data.data);

                Object.entries(message.data.data).forEach(([varName, varValue]) =>
                    setCSSVar('--sa-' + varName, varValue as string)
                );
                return;
            default:
                return;
        }
    };

    if (listening) {
        window.removeEventListener('message', listener);
        listening = false;
    }

    if (!listening) {
        window.addEventListener('message', listener);
    }
    listening = true;

    return listener;
};

export const setChatLoaderWebsocket = (websocket: SmartagentChatWebsocketType) => {
    ws = websocket;
};

export const invalidateChatLoaderWebsocket = () => {
    ws = null;
};

export default listenToLoaderMessages;
